  export enum InsuranceActionTypes {
    GET_MASTER_CONFIG = 'GET_MASTER_CONFIG',
  }
  